import { createContext } from "react";

const datacontext = createContext();

export default datacontext;